import { render, staticRenderFns } from "./input-phone.vue?vue&type=template&id=48f40ac8&scoped=true"
import script from "./input-phone.vue?vue&type=script&lang=js"
export * from "./input-phone.vue?vue&type=script&lang=js"
import style0 from "./input-phone.vue?vue&type=style&index=0&id=48f40ac8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f40ac8",
  null
  
)

export default component.exports